import * as React from "react";
import axios from 'axios';
import { EditorState,convertFromRaw,convertToRaw } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./CardObject.css"
//import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Intent, Classes } from "@blueprintjs/core";
import { Button,ButtonGroup, Card, Elevation, Overlay,H4 } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
import CardEditor from "./CardEditor.tsx";


import {Toaster, Position} from "@blueprintjs/core";
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});


export default class CardEditorViewer extends React.Component  <HomeProps> {
  state = {
    name: '',
    file:'',
    zoom:0.5,
    largeur:'620px',
    isOpenPdf:'none',
    isNotOpenPdf:'flex',
    numPages:0,
    force_width:'360px',
    isOpenEdit:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    isOpenDelete:false,
    status_published:"eye-off",
    showcontenu:'block',
    elargir:'arrow-right',
    parent_height:'auto',
    editorState: EditorState.createEmpty(),
    isOpenEditor:true,
    isSaveEditor:false,
    tailletexte:0,
    contenu:'',
    recordingsbydate:'',
    is_upload:false
  }  
  
  constructor(props) {
        super(props);
        this.setState({file:props.url_video})
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    this.setState({file:this.props.url_video})
    this.setState({title_document_creation:this.props.title_document});
    this.setState({description_document_creation:this.props.description});
    this.setState({objectif_document_creation:this.props.objectif});
    this.loadText(this.props.url_video);
       
  }
 
  componentDidUpdate(prevProps, prevState) {
    //console.log(prevProps)
    if(prevProps.url_video!=this.state.file) {this.setState({file:prevProps.url_video});this.loadText(prevProps.url_video);}
  }
  handle_published=()=>
  {
    console.log("handle_published");
    if(this.state.status_published=='eye-off'){
      this.setState({status_published:'eye-open'});
      toaster.show( {icon:'eye-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document est disponible en ligne"});
    }else{
      this.setState({status_published:'eye-off'});
      toaster.show( {icon:'eye-off', intent:Intent.DANGER,timeout:2000,message:"Le document n'est plus disponible en ligne"});
    }
  }
 
  
  handletaille=()=>{
    this.setState({force_width:"100%"});
    this.setState({showcontenu:"block"});
    this.setState({elargir:"arrow-left"});
  }
  loadText=(url)=>
  {
   
    //url=url+"&timestamp="+new Date().getTime();  
    axios.get(url, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
          'Content-Type': 'application/json'
        },
        responseType: "json"
      })
        .then(response => {
         
          console.log(response.data);
          const rawContent = convertFromRaw(response.data);
          this.setState({ editorState: EditorState.createWithContent(rawContent) })
        })
      /*  .catch(err => {
          console.log("error", err);
        });*/
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
    });    
  };
  onContentStateChange: Function = (contentState) => {
    this.setState({
      contentState,
    });
    var contentState2=this.state.editorState.getCurrentContent()
    var contenu_=JSON.stringify(convertToRaw(contentState2));//, null, 4)
    console.log(contenu_);
    if(this.state.tailletexte!=contenu_.length){this.setState({tailletexte:contenu_.length});this.setState({contenu:contenu_});this.setState({isSaveEditor:true});}
    
  };
  sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
  
  
  render() {
    const { editorState } = this.state;
    const {youtube_frame,url_video,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handlehandleSelectionGetLoginSelectionChangeLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;

    return(
     <div style={{display:isnotdocument,width:this.state.force_width,margin:4}}>
     
     <Card style={{width:this.state.force_width,margin:4,objectFit:'contain'}} interactive={true} elevation={Elevation.TWO}>
     <div style={{textAlign: 'right'}}>
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"80px"});this.setState({showcontenu:"none"});this.setState({typeflex:'initial'})}} className={Classes.OUTLINED } icon="minimize" title="Réduire" />
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"auto"});this.setState({showcontenu:"block"});if(this.props.type_audio =='true') this.setState({typeflex:'100%'});if(this.props.type_audio =='true') this.setState({parent_height:280})}} className={Classes.OUTLINED } icon="maximize" title="Augmenter" />
       <Button onClick={(ev)=>{
          ev.preventDefault();
          if(this.state.elargir=='arrow-right')
          {
            this.setState({force_width:"100%"});
            this.setState({showcontenu:"block"});
            this.setState({elargir:"arrow-left"});
            this.setState({isOpenPdf:'flex'});
            this.setState({isNotOpenPdf:'none'});
          }
          else
          {
            this.setState({force_width:"360px"});
            this.setState({elargir:"arrow-right"});
            this.setState({isOpenPdf:'none'});
            this.setState({isNotOpenPdf:'flex'});
          }
        }}
              
        className={Classes.OUTLINED } icon={this.state.elargir} title="Elargir" />
     </div>
     <h3><a href="">{title_document}</a></h3>
     <p><b>{description}</b></p>
     <p>{objectif}</p>
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:true});}} className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>}
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
     {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon={this.state.status_published} title="Cours en ligne" onClick={(ev)=>{ev.preventDefault();this.handle_published();}}/>:<div></div>}
     {this.props.toolbar!='true'?<CardEditor _onUploadtext={this.props._onUploadtext} fromChildren={this.props.fromChildren} matiere_id={this.props.matiere_id} handletaille={this.handletaille} userid={this.props.userid} recordingsbydate={this.props.recordingsbydate} id_document={this.props.id_document} title_document={title_document}/>:null}
     <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le document {this.props.title_document}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le document {this.props.title_document} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/deldocument?id_document='+this.props.id_document)
                              this.setState({file:''})
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          //that.props.onchildrenevent();
                                          that.props.LoadDataDocumentsDirect(-1)
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
     </Overlay>
    
      <div style={{display:this.state.showcontenu,zIndex:0}}>
     
       <div style={{marginTop:25}} >{/*style={{transform: "scale("+this.state.zoom+")", width:this.state.largeur}} className="Example__container">*/}
      <Editor
      editorState={editorState}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
      toolbar={{options:[]}}
      readOnly={true}
      onEditorStateChange={this.onEditorStateChange}
      onContentStateChange={this.onContentStateChange}
    />
      
        
      </div>
      </div>
    </Card>
    <Overlay isOpen={this.state.isOpenEdit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
      
        <H4>Edition d'un document</H4>
        <div style={{marginTop:5}}><span>Titre</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:ev.target.value,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation});this.setState({title_document_creation:ev.target.value})}} value={this.state.title_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir le titre de votre document"/></div>
        <div style={{marginTop:5}}><span>Description</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:ev.target.value,objectif:this.state.objectif_document_creation});this.setState({description_document_creation:ev.target.value})}} value={this.state.description_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir une description votre document"/></div>
        <div style={{marginTop:5}}><span>Objectif</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:ev.target.value});this.setState({objectif_document_creation:ev.target.value})}} value={this.state.objectif_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir un objectif ou une consigne"/></div>
        <div style={{marginTop:10}}>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:false});}}>Annuler</Button>
          <Button style={{marginLeft:5}} intent={Intent.SUCCESS} onClick={(ev)=>{ev.preventDefault();this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation,update:true});this.setState({isOpenEdit:false});}}>Valider la modification</Button>
        </div>
      </div>
      </Overlay>
    </div>);
   
}
}


 
 
 
 
 
 /*
 
  state = {
    name: '',
    force_height:'240px',
    force_height2:'480px',
    force_width:'360px',
    parent_height:480,
    isOpenEdit:false,
    isOpenDelete:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    typeflex:'initial',
    status_published:"eye-off",
    youtube_frame:'',
    showcontenu:'block',
    url_video:'',
    elargir:'arrow-right',
    url_video2:'',
    editorState: EditorState.createEmpty(),
    isOpenEditor:false,
    isSaveEditor:false,
    tailletexte:0,
    contenu:'',
    recordingsbydate:'',
    is_upload:false
  }  
 
  
  constructor(props) {
        super(props);
        if(this.props.handleEdition!=undefined)this.props.handleEdition.bind(this);
       // this.handleChange = this.handleChange.bind(this);
      }
  
  componentDidMount () { 
   var that=this;
   this.setState({title_document_creation:this.props.title_document});
   this.setState({description_document_creation:this.props.description});
   this.setState({objectif_document_creation:this.props.objectif})
   this.setState({youtube_frame:this.props.youtube_frame});
   this.setState({url_video:this.props.url_video});
   window.addEventListener("message", this.handlerMessageiframe);
   var host=window.location.toString();
   var ll=host;
   if(ll.split('https:').length>1)host="";
   if(ll.split('http:').length>1)host="";
   
    if(this.props.type_audio =='true') {
      this.setState({force_height:'80px'}); 
      this.setState({loadthegraph:'needloaded'})
    }
    this.setState({parent_height:480})
    if(this.props.type_audio =='true') this.setState({typeflex:'100%'})
    else this.setState({typeflex:'initial'})
       
 
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.props.recordingsbydate==undefined)return;
    if(this.state.recordingsbydate!=this.props.recordingsbydate)
    {
      this.setState({recordingsbydate:this.props.recordingsbydate})
      {
        this.props.recordingsbydate.map((item)=>
        {
          item.recordings.map((it)=>{
            if(it.type=="text")
            {
              if (it.data.includes(this.props.userid+"_"+this.props.id_document+".jsontext"))
              {
                console.log("a charger");
                this.loadText(it.data);
              }
            }
          })
        });
      }
    }
    
  }
 
  
   componentWillUnmount(): void {
   
 }

   render() {
    const { editorState } = this.state;
    const {type_audio,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
    
   
    

    return(
     this.props.userid!=undefined?<div>
     
     {this.props.toolbar!='true'?<Button onClick={(ev)=>
      {
        ev.preventDefault();
        this.props.handletaille();
        if(this.state.isOpenEditor==false) this.setState({isOpenEditor:true});
        else  this.setState({isOpenEditor:false});
      }}
      className={(!this.state.isOpenEditor?Classes.OUTLINED:"") +" "+ Classes.LARGE +" "+ Classes.INTENT_SUCCESS} icon="edit" title="Editer" />:null}

     {this.state.isSaveEditor ==true?<Button onClick={(ev)=>
      {
        ev.preventDefault();
        this.setState({isSaveEditor:false});
        this.props._onUploadtext( this.state.contenu,this.props.id_document,this.props.title_document);
      }}
      className={Classes.OUTLINED +" "+ Classes.LARGE} intent={Intent.DANGER} icon="floppy-disk" title="Sauvegarder" />:null}
     <Button className={(!this.state.is_upload?Classes.OUTLINED:"") +" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon="cloud-upload" title="Déposer un document" onClick={(ev)=>{ev.preventDefault();this.setState({is_upload:!this.state.is_upload});this.props.handletaille();}}/>
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:null}
    
     {this.state.is_upload ? <iframe style={{marginTop:5,border:0,width:'100%',height:'530px'}} src='upload/index.html'></iframe>:<div></div>}
     {this.state.isOpenEditor?<div>{this.props.title_document}<br/><Editor
      editorState={editorState}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
      toolbar={{options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker',  'history'],
        inline: { inDropdown: true },
        list: { inDropdown: true },
        textAlign: { inDropdown: false },
        history: { inDropdown: false },
      }}
      onEditorStateChange={this.onEditorStateChange}
      onContentStateChange={this.onContentStateChange}
    /></div>:null}
     </div>:null
    );
}
}*/
